import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExcel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={21} height={21} fill='none' {...props}>
    <path
      stroke='#089981'
      strokeLinecap='round'
      d='M3.251 5.071V2.357A1.357 1.357 0 0 1 4.61 1H18.18a1.357 1.357 0 0 1 1.357 1.357v16.286A1.357 1.357 0 0 1 18.18 20H4.609a1.357 1.357 0 0 1-1.358-1.357v-2.714m0-8.143 5.429 5.428m-5.429 0L8.68 7.786M1.894 5.07h8.143a1.357 1.357 0 0 1 1.357 1.358v8.142a1.357 1.357 0 0 1-1.357 1.358H1.894A1.357 1.357 0 0 1 .537 14.57V6.43A1.357 1.357 0 0 1 1.894 5.07Z'
    />
  </svg>
);
export default SvgExcel;
